export default "__VITE_ASSET__BDj5kqyG__"